import { Controller } from '@hotwired/stimulus'
import Sortable from 'sortablejs'

export default class extends Controller {
    static targets = ['sortable']

    sortable = null

    connect() {
        this.enableSorting()

        this.reorder = () => this.reorderConversions()
        document.addEventListener('conversions:reorder', this.reorder)
    }

    disconnect() {
        document.removeEventListener('conversions:reorder', this.reorder)
        this.sortable?.destroy()
    }

    reorderConversions() {
        const conversionGroups = document.querySelectorAll(
            '.conversion-group.list-group-item:not(.hidden-conversion)',
        )

        Array.from(conversionGroups).forEach((conversionGroup, i) => {
            const count = `${i + 1}`
            const orderElement = conversionGroup.querySelector('.order')
            orderElement.innerHTML = count

            const orderInputField = conversionGroup.querySelector('input[id*="_eval_order"]')
            orderInputField.value = count
        })
    }

    enableSorting() {
        if (!this.hasSortableTarget) return

        this.sortable = new Sortable(this.sortableTarget, {
            handle: 'span.move-handler',
            onEnd: () => {
                this.reorderConversions()
            },
        })
    }
}
